import { Component, Inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FileUploadDialogModel, FileUploadDialogResponseModel } from "src/app/models/dialog";
import { SessionService } from "src/app/services/storage/session.service";
import { BenefitCheckoutWizardPanel, BenefitWizardType } from "src/app/constants/wizard-panels";
import { FileUploadService } from "src/app/services/file-upload.service";
import { DocumentPayload, FileUploadResponse, QLEDocument } from "src/app/models/document";
import { DbCommon } from "src/app/constants/dbCommon";

@Component({
    selector: 'mwp-dialog-file-upload',
    templateUrl: './file-upload.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogFileUploadComponent implements OnInit {

    public isValid: boolean;
    public displayConfigError: boolean;
    public displayFlynnCustomMessage: boolean;
    public files: File[];
    public responseModel: FileUploadDialogResponseModel;

    constructor(
        private dialogRef: MatDialogRef<DialogFileUploadComponent>,
        private fileUploadService: FileUploadService,
        private sessionService: SessionService,
        @Inject(MAT_DIALOG_DATA) public fileUploadDialogModel: FileUploadDialogModel,
    ) {
    }

    ngOnInit(): void {
        this.responseModel = new FileUploadDialogResponseModel();
        if (this.sessionService.session.member.companyName == 'FLYNN RESTAURANT GROUP') {
            this.displayFlynnCustomMessage = true;
        }
    }

    public updateFiles(event: File[]): void {
        this.files = event;
        this.isValid = this.files && this.files.length > 0;

        if (this.fileUploadDialogModel.wizardType != BenefitWizardType.Checkout) {
            this.responseModel.files = event;
            this.responseModel.isValid = this.isValid;
        }
    }

    public saveDocuments(): void {
        let l_ConfigError: boolean = true;

        if (this.fileUploadDialogModel.wizardType) {
            switch(this.fileUploadDialogModel.wizardType) {
                case BenefitWizardType.Checkout:
                    if (this.fileUploadDialogModel.panelName == BenefitCheckoutWizardPanel.dependentVerify){
                        l_ConfigError = false;
                        this.uploadDependentDocuments();
                    }
                    break;
            }
        } else if (this.fileUploadDialogModel.qLERequestID) {
            l_ConfigError = false;
            const l_DocumentPayload = new DocumentPayload();
            l_DocumentPayload.dependentID = DbCommon.emptyInt;
            l_DocumentPayload.qleRequestID = this.fileUploadDialogModel.qLERequestID;
            l_DocumentPayload.files = this.files;

            this.fileUploadService.uploadQLEDocuments(l_DocumentPayload).subscribe((response: QLEDocument[]) => {
                this.dialogRef.close({ dialogResult: response });
            });
        } else {
            l_ConfigError = false;
            this.uploadDependentDocuments();
        }

        this.displayConfigError = l_ConfigError;
    }

    private uploadDependentDocuments(): void {
        const l_DocumentPayload = new DocumentPayload();
        l_DocumentPayload.dependentID = this.fileUploadDialogModel.dependentId;
        l_DocumentPayload.files = this.files;

        this.fileUploadService.uploadDependentDocuments(l_DocumentPayload).subscribe((response: FileUploadResponse) => {
            if (!response.failedUploadCount || response.failedUploadCount < 0)
                this.closeDialog();
        });
    }

    public closeDialog(): void {
        this.dialogRef.close();
    }
}